import React from 'react';

import { Slider } from '@/components/ui/slider';

type SliderInputProps = {
  iconLabel: JSX.Element;

  step?: number;
  marks?: boolean;
  units: string;
  min?: number;
  max?: number;

  value: number;
  setValue: (v: number) => void;
};

export default function RawSliderInput({ iconLabel, value, setValue, units, min, max, step }: SliderInputProps) {
  return (
    <div className="flex flex-row items-center gap-2 justify-between w-full">
      <div className="min-w-6 leading-none flex-shrink-0">{iconLabel}</div>
      <Slider
        value={[value]}
        onValueChange={([newValue]) => setValue(newValue)}
        min={min}
        max={max}
        step={step}
        className="flex-1"
      />
      <div className="min-w-8 text-right flex-shrink-0">
        <span className="text-sm text-muted-foreground leading-none">
          {value}
          {units}
        </span>
      </div>
    </div>
  );
}
